var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { ITimeoutService } from 'angular';
import { Component } from 'decorators';
import { BuilderFeatures } from '../../BuilderFeatures';
import { DESK_ID_PREFIX, STATE_ID_END, STATE_ID_FALLBACK, STATE_ID_ONBOARDING, BuilderStateService } from '../../services/BuilderStateService';
import './builderNode.scss';
import BuilderNodeView from './BuilderNodeView.html';
import { AlertService } from 'modules/shared/AlertService';
var BlockTypes;
(function (BlockTypes) {
    BlockTypes["Desk"] = "desk";
    BlockTypes["Subflow"] = "subflow";
    BlockTypes["Node"] = "node";
})(BlockTypes || (BlockTypes = {}));
let BuilderNodeComponent = class BuilderNodeComponent {
    static $inject = ['$timeout', 'BuilderStateService', '$translate', 'AlertService'];
    constructor($timeout, BuilderStateService, $translate, AlertService) {
        'ngInject';
        this.$timeout = $timeout;
        this.BuilderStateService = BuilderStateService;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.nodeStatus = false;
    }
    async $onInit() {
        this.checkFeatures();
        this.$onContextMenu();
        this.nodeStatus = await this.$onUpdateNodeStatus(this);
    }
    get _viewTitle() {
        if (!this.nodeTitle) {
            return this.defaultTitle;
        }
        return this.nodeTitle;
    }
    isDefaultNode(nodeId) {
        return [STATE_ID_ONBOARDING, STATE_ID_FALLBACK, STATE_ID_END].includes(nodeId);
    }
    $onEdit($node) {
        this.onEdit({ $node });
    }
    async $onDelete($node) {
        if (!this.isSubflowBlock) {
            this.onDelete({ $node });
        }
        else {
            await this.AlertService.show({
                title: await this.$translate('builder.subflow.deleteSubflowModalTitle'),
                body: await this.$translate('builder.subflow.deleteSubflowModalDescription'),
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: await this.$translate('builder.subflow.deleteSubflowModalButtonNo'),
                    confirm: await this.$translate('builder.subflow.deleteSubflowModalButtonYes'),
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: async () => { this.onDelete({ $node }); },
                },
            });
        }
    }
    $onDuplicate($node) {
        this.onDuplicate({ $node });
    }
    $onCopySelectedNodes() {
        this.onCopySelectedNodes();
    }
    $onCopyNodeId($node) {
        this.onCopyNodeId({ $node });
    }
    $onUpdateElement($node) {
        this.$timeout(() => {
            this.onUpdateElement && this.onUpdateElement({ $node });
        }, 600); // Necessary due to tags animation delay
    }
    $onUpgradeState($node) {
        this.onUpgradeState({ $node });
        this.isDeskStateOutdated = false;
    }
    $onContextMenu() {
        if (this.onContextMenu) {
            this.onContextMenu();
        }
        this.checkDeskVersion();
    }
    $onEnterSubFlow($node) {
        this.onEnterSubFlow({ $node });
    }
    $onEditSubFlow($node) {
        this.onEditSubFlow({ $node });
    }
    async $onUpdateNodeStatus($node) {
        return this.onUpdateNodeStatus({ $node });
    }
    checkDeskVersion() {
        this.isDeskStateOutdated = this.displayUpgradeDeskVersion && (this.nodeId?.startsWith(DESK_ID_PREFIX) && (this.BuilderStateService.deskStateVersion > parseFloat(this.deskStateVersion) || !this.deskStateVersion));
        this.nodeType = this.nodeId.includes(BlockTypes.Desk) ? BlockTypes.Desk : this.nodeId.includes(BlockTypes.Subflow) ? BlockTypes.Subflow : BlockTypes.Node;
        this.isSubflowBlock = this.nodeType === BlockTypes.Subflow;
    }
    async checkFeatures() {
        this.displayUpgradeDeskVersion = await BuilderFeatures.displayUpgradeDeskVersion();
    }
};
BuilderNodeComponent.$inject = ['$timeout', 'BuilderStateService', '$translate', 'AlertService'];
BuilderNodeComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: BuilderNodeView,
        bindings: {
            defaultTitle: '@',
            nodeId: '@',
            nodeTitle: '@',
            nodeImageUri: '@',
            isAiGenerated: '=?',
            isStateOutdated: '=?',
            isBuilderImprovedCopyPasteFeatureEnabled: '@',
            nodeTags: '<',
            onEdit: '&?',
            onDelete: '&?',
            onDuplicate: '&?',
            onCopySelectedNodes: '&?',
            onCopyNodeId: '&?',
            onUpdateElement: '&?',
            onUpgradeState: '&?',
            onContextMenu: '&?',
            onEnterSubFlow: '&?',
            onEditSubFlow: '&?',
            onUpdateNodeStatus: '&?',
            deskStateVersion: '@?',
            hideCreateOuputByDiagram: '=?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _a : Object, typeof (_b = typeof BuilderStateService !== "undefined" && BuilderStateService) === "function" ? _b : Object, Object, typeof (_c = typeof AlertService !== "undefined" && AlertService) === "function" ? _c : Object])
], BuilderNodeComponent);
export { BuilderNodeComponent };
